export const ontologyGroups = ['actors', 'work', 'information', 'technology', 'governance', 'outcomes', 'other'] as const
export type OntologyGroup = typeof ontologyGroups[number]

export const ontologyGroupStyles: Record<OntologyGroup, { accent: string; dot: string; selected: string; tint: string }> = {
  actors: { accent: 'bg-violet-500', dot: 'bg-violet-500', selected: 'border-violet-500 ring-violet-500/15', tint: 'bg-violet-500/[0.035]' },
  work: { accent: 'bg-amber-500', dot: 'bg-amber-500', selected: 'border-amber-500 ring-amber-500/15', tint: 'bg-amber-500/[0.035]' },
  information: { accent: 'bg-blue-500', dot: 'bg-blue-500', selected: 'border-blue-500 ring-blue-500/15', tint: 'bg-blue-500/[0.035]' },
  technology: { accent: 'bg-cyan-500', dot: 'bg-cyan-500', selected: 'border-cyan-500 ring-cyan-500/15', tint: 'bg-cyan-500/[0.035]' },
  governance: { accent: 'bg-rose-500', dot: 'bg-rose-500', selected: 'border-rose-500 ring-rose-500/15', tint: 'bg-rose-500/[0.035]' },
  outcomes: { accent: 'bg-emerald-500', dot: 'bg-emerald-500', selected: 'border-emerald-500 ring-emerald-500/15', tint: 'bg-emerald-500/[0.035]' },
  other: { accent: 'bg-slate-400', dot: 'bg-slate-400', selected: 'border-slate-500 ring-slate-500/15', tint: 'bg-slate-500/[0.025]' },
}

const KIND_GROUPS: Record<OntologyGroup, string[]> = {
  actors: ['pessoa', 'papel', 'role', 'organizacao', 'parceiro_operacional', 'stakeholder', 'time', 'equipe', 'agente'],
  work: ['operacao', 'processo', 'fase', 'capacidade', 'metodo', 'abordagem', 'modelo_operacional', 'atividade', 'acao'],
  information: ['objeto', 'business_object', 'dominio_de_dados', 'dado', 'dados', 'evento', 'documento'],
  technology: ['sistema', 'plataforma_de_dados', 'canal', 'integracao', 'aplicacao'],
  governance: ['regra', 'rule', 'politica', 'decisao', 'restricao', 'risco'],
  outcomes: ['objetivo', 'problema', 'proposta', 'resultado', 'metrica', 'kpi', 'indicador', 'oportunidade'],
  other: [],
}

function normalizeKind(value: string) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[\s-]+/g, '_')
}

export function groupForKind(kind: string): OntologyGroup {
  const normalized = normalizeKind(kind)
  return ontologyGroups.find((group) => KIND_GROUPS[group].includes(normalized)) || 'other'
}

export function groupForFamily(familyKey?: string): OntologyGroup {
  return ({ actors: 'actors', operations: 'work', information: 'information', technology: 'technology', governance: 'governance', value: 'outcomes', other: 'other' } as Record<string, OntologyGroup>)[familyKey || ''] || 'other'
}
